require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./achats-des-biens-et-des-services-dabs-1-1-11.json") })
        }
      }, "path---achats-des-biens-et-des-services-dabs-1-1-11");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---achats-des-biens-et-des-services-dabs-1-1-11!./.cache/json/achats-des-biens-et-des-services-dabs-1-1-11.json
// module id = 316
// module chunks = 231608221292675